import { useState, useCallback, useMemo } from 'react';
import { RadioChangeEvent } from 'antd';
import {
  TS_PLOT_VALIDATION,
  SCATTER_PLOT_VALIDATION,
  ROSE_PLOT_VALIDATION,
} from '../../../../utils/common';
import { BASIC_ANALYTICS } from '../../../../types/analytics';
import { ValidationTabsEnum } from '../../../../types/validation';
import {
  EVENT_VALIDATION_INSITU_UPDATED,
  trackUpdate,
} from '../../../../utils/matomoEvents';
import { IMarker } from '../../../../types/marker';

export function usePlotSelection(
  activeValidationTab: ValidationTabsEnum,
  isActiveSubscriber: boolean,
  activePoint?: IMarker
) {
  const [activeInsituTab, setActiveInsituTab] = useState(
    isActiveSubscriber ? TS_PLOT_VALIDATION : SCATTER_PLOT_VALIDATION
  );

  const handleChangeInsituTab = useCallback(
    (e: RadioChangeEvent) => {
      const selectedValue = e.target.value;

      if (activePoint?.coordinates && activePoint?.dataset) {
        let analyticsType: string;

        switch (selectedValue) {
          case TS_PLOT_VALIDATION:
            analyticsType = BASIC_ANALYTICS.TIME_SERIES.toLowerCase();
            break;
          case SCATTER_PLOT_VALIDATION:
            analyticsType = BASIC_ANALYTICS.SCATTER_PLOT.toLowerCase();
            break;
          case ROSE_PLOT_VALIDATION:
            analyticsType = BASIC_ANALYTICS.ROSE_PLOT.toLowerCase();
            break;
          default:
            analyticsType = BASIC_ANALYTICS.SCATTER_PLOT.toLowerCase();
        }

        trackUpdate(
          EVENT_VALIDATION_INSITU_UPDATED,
          activePoint.coordinates,
          activePoint.dataset,
          analyticsType
        );
      }

      setActiveInsituTab(selectedValue);
    },
    [activePoint]
  );

  const radioGroupOnChange = useCallback(
    (e: RadioChangeEvent) => {
      if (activeValidationTab === ValidationTabsEnum.INSITU_TAB) {
        handleChangeInsituTab(e);
      }
    },
    [activeValidationTab, handleChangeInsituTab]
  );

  const radioGroupValue = useMemo(() => {
    return activeValidationTab === ValidationTabsEnum.INSITU_TAB
      ? activeInsituTab
      : SCATTER_PLOT_VALIDATION;
  }, [activeValidationTab, activeInsituTab]);

  const isTimeSeriesDisabled = useMemo(() => {
    if (activeValidationTab === ValidationTabsEnum.SATELLITE_TAB) {
      return true;
    } else if (activeValidationTab === ValidationTabsEnum.INSITU_TAB) {
      return !isActiveSubscriber;
    }
    return false;
  }, [activeValidationTab, isActiveSubscriber]);

  const isScatterPlotDisabled = useMemo(() => {
    return false;
  }, []);

  const isRosePlotDisabled = useMemo(() => {
    return true;
  }, []);

  return {
    activeInsituTab,
    setActiveInsituTab,
    radioGroupOnChange,
    radioGroupValue,
    isTimeSeriesDisabled,
    isScatterPlotDisabled,
    isRosePlotDisabled,
    handleChangeInsituTab,
  };
}
